// Registry of all generated clients — the single place that touches the per-service
// `client` singletons. Runtime configuration (baseURL, interceptors) iterates over this registry.
import { client as agw } from '../agw/client.gen';
import { client as ais } from '../ais/client.gen';
import { client as ass } from '../ass/client.gen';
import { client as erp } from '../erp/client.gen';
import { client as fis } from '../fis/client.gen';
import { client as fisDirect } from '../fis-direct/client.gen';
import { client as fns } from '../fns/client.gen';
import { client as fnsDirect } from '../fns-direct/client.gen';
import { client as hub } from '../hub/client.gen';
import { client as ios } from '../ios/client.gen';
import { client as iosDirect } from '../ios-direct/client.gen';
import { client as nos } from '../nos/client.gen';
import { client as tis } from '../tis/client.gen';
/** Gateway clients — frontend calls via `tf-agw` (paths prefixed with `/{tenant}/{company}/`). */
export const gatewayClients = { agw, ais, ass, erp, fis, fns, hub, ios, nos, tis };
/** Direct clients — backend-to-backend (services called directly, without the gateway prefix). */
export const directClients = { fnsDirect, fisDirect, iosDirect };
export const clients = { ...gatewayClients, ...directClients };
